export const formatDate = (date) => {
  const dateOptions = { timeZone: 'America/New_York', year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(date).toLocaleDateString('en-US', dateOptions);
};

const numberFormatter = (n, options) => {
  const formatter = new Intl.NumberFormat('en-US', options);
  return formatter.format(n);
};

export const NUMBER_FORMATS = {
  currency: (n, precision = 2) => {
    return numberFormatter(n, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
    });
  },
  integer: (n) => {
    return numberFormatter(n, {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  },
  decimal: (n, precision = 2) => {
    return numberFormatter(n, {
      style: 'decimal',
      maximumFractionDigits: precision,
    });
  },
  percent: (n, precision = 2) => {
    return numberFormatter(n / 100, {
      style: 'percent',
      maximumFractionDigits: precision,
    });
  },
};
